import { FC, ReactElement } from 'react';
import AppModal from '../app-modal/AppModal';
import { Modal } from 'react-bootstrap';
import i18next from 'i18next';
import { PatientListDto } from '../../../../shared/dtos/patient.dto';
import { TelerehabilitationProgramDto } from '../../../../shared/dtos/telerehabilitationProgram.dto';
import PatientForm from './PatientForm';

type PatientEditModalProps = {
  show: boolean;
  patient: PatientListDto;
  telerehabilitationPrograms: TelerehabilitationProgramDto[];
  onClose: () => void;
  onSave: (savedSocialSecurityNumber?: string | null) => void;
}

const PatientEditModal: FC<PatientEditModalProps> = ({
  show,
  patient,
  telerehabilitationPrograms,
  onClose,
  onSave
}: PatientEditModalProps): ReactElement => {
  return (
    <AppModal 
      size="lg"
      dialogClassName="modal-dialog-centered"
      show={show} 
      onHide={onClose} 
      backdrop="static" 
      keyboard
    >
      <Modal.Header closeButton>
        <Modal.Title>{i18next.t('patientEditModal.title')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <PatientForm 
          data={{
            patientId: patient.id,
            firstName: patient.patientInfo.givenName,
            lastName: patient.patientInfo.familyName,
            email: patient.patientInfo.email,
            telerehabilitationProgram: patient.telerehabilitationProgram,
            socialSecurityNumber: patient.patientInfo.ssn,
            startDate: patient.patientInfo.teleRehaAftercareStart ? new Date(patient.patientInfo.teleRehaAftercareStart) : undefined,
            endDate: patient.patientInfo.teleRehaAftercareEnd ? new Date(patient.patientInfo.teleRehaAftercareEnd) : undefined,
          }} 
          telerehabilitationPrograms={telerehabilitationPrograms} 
          onClose={onClose} 
          onSubmit={(savedSocialSecurityNumber?: string | null) => {
            onSave(savedSocialSecurityNumber);
            onClose();
          }}
        />
      </Modal.Body>
    </AppModal>
  );
};


export default PatientEditModal;
